
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/[blog_slug]",
      function () {
        return require("private-next-pages/blogs/[blog_slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/[blog_slug]"])
      });
    }
  